class UiService {
    private commands = {}

    public registerCommand(command: string, action: any, asyncParamName: string = "") {
        this.commands[command] = {
            action, asyncParamName,
        }
    }
    public executeCommand(command: string, params: any = {}, async: boolean = false) {
        try {
            const { action, asyncParamName } = this.commands[command]
            if (async) {
                return new Promise((resolve, reject) => {
                    params[asyncParamName] = (data) => {
                        resolve(data)
                    }
                    action(params)
                })
            } else {
                const { action } = this.commands[command]
                action(params)
            }
        } catch (e) {
            console.log(e);
        }
    }

    public getCommands() {
        return this.commands;
    }
}

export default new UiService()
